import { useState, useEffect, useContext } from 'react';
import './Sidebar.css';
import Menu from './Menu/Menu';
import { getBaseUrl } from '../../../utils/getUrl';
import AuthContext from '../../../store/auth-context';
import { isMobile } from '../../../utils/isMobile';
import { TabContext } from '../../Context/TabContext';
import { useTranslation } from 'react-i18next';
import MobileNotificationsBar from './MobileNotificationsBar';

function Sidebar() {
  const { t } = useTranslation();
  const api = getBaseUrl();
  const [open, setOpen] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [active, setActive] = useState(null);
  const [items, setItems] = useState([]);

  const authContext = useContext(AuthContext);
  const tabContext = useContext(TabContext);

  const closeMenu = () => setOpen(false);

  const openItem = (item) => {
    tabContext.addTab(item);
  };

  useEffect(() => {
    const axios = require('axios');
    const FormData = require('form-data');
    const formData = new FormData();

    formData.append('IdMenija', +localStorage.idMenija);

    const config = {
      method: 'POST',
      url: `${api}VratiOpcijeMenija_web`,
      data: formData,
    };

    axios(config).then((response) => {
      setItems(response.data[0].items[0].items);
    });
  }, []);

  return (
    <>
      {isMobile() && (
        <MobileNotificationsBar onOpenMenu={() => openItem(items[1])} />
      )}
      <div className="items_wrapper">
        <ul>
          {items.map((item) => {
            const itemStyle = ['item'];
            if (active === item.title) {
              itemStyle.push('active_item');
            }
            return (
              <li
                key={item.title}
                className={itemStyle.join(' ')}
                onClick={() => openItem(item)}
              >
                <span className="icon_container">
                  <i className={item.icon} />
                </span>
                <span className="text_container">
                  {t(`menuItem.${item.title}`).includes('menuItem')
                    ? item.title
                    : t(`menuItem.${item.title}`)}
                </span>
              </li>
            );
          })}
        </ul>
        <span className="item logout" onClick={authContext.logout}>
          <span className="icon_container">
            <i className="fas fa-power-off" style={{ fontSize: '1.3rem' }} />
          </span>
          <span className="text_container">{t('buttons.logOut')}</span>
        </span>
      </div>
      <Menu open={open} items={menuItems} closeMenu={closeMenu} />
    </>
  );
}

export default Sidebar;
